import {
    START_PAGE_SPINNER,
    START_PRES_CREATE_SPINNER,
    START_PRES_UPDATE_SPINNER,
    STOP_PAGE_SPINNER,
    STOP_PRES_CREATE_SPINNER,
    STOP_PRES_UPDATE_SPINNER,
    START_WINDOW_RESIZE_SPINNER,
    STOP_WINDOW_RESIZE_SPINNER,
} from '../actions/spinner';
import {SpinnerReducerType} from '../actions/types/spinner.types';

export interface SpinnerReducerState {
    pageSpinner: boolean;
    presUpdateSpinner: boolean;
    presCreateSpinner: boolean;
    windowResizeSpinner: boolean;
    mask?: boolean;
}
export const preloadedState = {
    pageSpinner: false,
    presUpdateSpinner: false,
    presCreateSpinner: false,
    windowResizeSpinner: false,
    mask: false,
};

export const spinnerReducer = (state: SpinnerReducerState = preloadedState, action: SpinnerReducerType): SpinnerReducerState => {
    switch (action.type) {
        case START_PAGE_SPINNER:
            return {...state, pageSpinner: true, mask: action.mask};
        case STOP_PAGE_SPINNER:
            return {...state, pageSpinner: false, mask: false};
        case START_PRES_UPDATE_SPINNER:
            return {...state, presUpdateSpinner: true, mask: action.mask};
        case STOP_PRES_UPDATE_SPINNER:
            return {...state, presUpdateSpinner: false, mask: false};
        case START_PRES_CREATE_SPINNER:
            return {...state, presCreateSpinner: true};
        case STOP_PRES_CREATE_SPINNER:
            return {...state, presCreateSpinner: false};
        case START_WINDOW_RESIZE_SPINNER:
            return {...state, windowResizeSpinner: true};
        case STOP_WINDOW_RESIZE_SPINNER:
            return {...state, windowResizeSpinner: false};
        default:
            return state;
    }
};
